import { Card, CardContent, CardHeader, CardTitle } from '@1trading/react';
import { History } from 'lucide-react';
import { AuditEntryArticle } from '@/components/audit/audit-entry-article';
import { QueryErrorBanner } from '@/components/feedback/query-error';
import { LoadingPanel } from '@/components/ui/loading-panel';
import { useMmProgramHistory } from '@/hooks/queries/mm-programs/use-mm-programs';
import { getErrorMessage } from '@/lib/api/error';

export const ProgramHistory = ({ pid }: { pid: string }) => {
  const query = useMmProgramHistory(pid);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <History className="size-4 text-muted-foreground" />
          Change history
        </CardTitle>
      </CardHeader>
      <CardContent>
        {query.isPending ? (
          <LoadingPanel className="py-8" />
        ) : query.isError ? (
          <QueryErrorBanner message={`Failed to load the change history: ${getErrorMessage(query.error)}`} onRetry={() => query.refetch()} />
        ) : query.data.length ? (
          <div className="flex flex-col gap-4">
            {query.data.map((entry) => (
              <AuditEntryArticle entry={entry} key={entry.s} />
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">No changes have been saved through BOP yet.</p>
        )}
      </CardContent>
    </Card>
  );
};
ProgramHistory.displayName = 'ProgramHistory';
